<template>
  <v-app>
    <!--
    <ul style="list-style-type: none">
      <li style="float:left; margin-right: 16px">
        <router-link to="/">Home</router-link>
      </li>
      <li>
        <router-link to="/login">Login</router-link>
      </li>
    </ul>-->

    <!-- Sizes your content based upon application components -->
    <v-main>
      <!-- Provides the application the proper gutter -->
      <v-container class="px-0 py-0">
        <router-view />
      </v-container>
    </v-main>

   <!-- <v-footer app></v-footer> -->
  </v-app>
</template>


<script>
//import HelloWorld from "./components/HelloWorld";
//import LoginForm from "./components/LoginForm";

export default {
  name: "App",
  components: {
    //HelloWorld,
    //LoginForm,
  },

  data: () => ({
    //
  }),
  /*
  mounted() {
    window.onpopstate = event => {
      
      if (
        window.localStorage.getItem("info") !== null &&
        this.$route.path == "/login"
      ) {
        this.$router.push("/"); 
      } 
    };
  }, */
};
</script>
